import { render, staticRenderFns } from "./WidgetInfrastructure.vue?vue&type=template&id=256a44ce&scoped=true"
import script from "./WidgetInfrastructure.vue?vue&type=script&lang=ts"
export * from "./WidgetInfrastructure.vue?vue&type=script&lang=ts"
import style0 from "./WidgetInfrastructure.vue?vue&type=style&index=0&id=256a44ce&prod&scoped=true&lang=scss"
import style1 from "./WidgetInfrastructure.vue?vue&type=style&index=1&id=256a44ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a44ce",
  null
  
)

export default component.exports